import { EXPERIENCES } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading, CtaLink } from "@/components/site/primitives";
import ConceptTag from "@/components/site/ConceptTag";

// Asymmetric bento layout spans (desktop)
const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

export default function ExperienceSection({ withCta = true }) {
  return (
    <section className="bg-rp-bg" data-testid="experience-section">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <Reveal className="max-w-3xl">
          <SectionHeading overline="The Experience" title={<>Every Detail.<br />Every Stop.</>} />
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-12">
          {EXPERIENCES.map((exp, i) => (
            <Reveal
              key={exp.key}
              delay={(i % 2) * 0.08}
              className={`col-span-1 ${SPANS[i]}`}
            >
              <article
                data-testid={`experience-card-${exp.key}`}
                className="group relative h-[360px] overflow-hidden rounded-2xl border border-white/10 md:h-[440px]"
              >
                <img
                  src={exp.image}
                  alt={exp.title}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                {exp.concept && <ConceptTag className="absolute right-4 top-4" />}
                <div className="absolute inset-x-0 bottom-0 p-7 md:p-9">
                  <span className="font-mono text-xs tracking-[0.2em] text-rp-accent">{exp.num}</span>
                  <h3 className="mt-2 font-display text-3xl font-light uppercase tracking-tight text-white md:text-4xl">
                    {exp.title}
                  </h3>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-white/70">{exp.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {withCta && (
          <Reveal className="mt-12" delay={0.1}>
            <CtaLink to="/experience" data-testid="experience-cta">Explore the RestPower Experience</CtaLink>
          </Reveal>
        )}
      </div>
    </section>
  );
}
